




import { Component, Mixins, Prop } from "vue-property-decorator";
import { ImageKinds, ImageSourceKinds } from "../../../../domain/document";
import {
  IImageDrawable,
  instanceOfIClaioSchemaExecutable,
} from "../../../../domain/document/items";
import {
  ClaioSchemaExecuteRequest,
  ClaioSchemaExecuteResult,
} from "../../../../domain/localhost/items";
import { Dictionary, SystemLogEventLevelKinds, SystemLogInformation } from "../../../../domain/system";
import { EditingDocument } from "..";
import { ApplicationDialogsAccessor } from "../CommonComponentsAccessor";
import { DomainRegistry } from "../../../../domain";

@Component
export default class ClaioSchemaAdapter extends Mixins() {
  @Prop()
  source: EditingDocument;

  @Prop()
  dialogs: ApplicationDialogsAccessor;

  isContentEditable(source: IImageDrawable, isClaioSchemaOnly: boolean): boolean {
    return instanceOfIClaioSchemaExecutable(source)
        && this.isEditableImagekind(source.imageKind, isClaioSchemaOnly)
        && (this.$configuration.behavior.document.editor.contents.schema.isEnable || this.$configuration.behavior.document.editor.imageEditor.claioSchema.isEnable)
        && source.isEditable;
  }

  private isEditableImagekind(imageKind: ImageKinds, isClaioSchemaOnly: boolean): boolean {
    return isClaioSchemaOnly
      ? (0 <= [ImageKinds.ClaioSchema, ImageKinds.ClaioSchemaEdit].indexOf(imageKind))
      : (imageKind !== ImageKinds.ClaioMovie);
  }

  async editContent(source: IImageDrawable): Promise<ClaioSchemaExecuteResult> {
    try {
      if (!this.isContentEditable(source, false)) {
        throw new Error(this.schemaName + "の起動対象のsourceではありません。実装を確認してください。");
      }
      this.addSystemLog("ClaioSchemaを起動します。");
      const result = await this.dialogs.launcher.show(
        null,
        this.editParameters,
        this.toEditRequest(source)
      );
      this.$logger.debug(result);
      if (!result || !result.imageSource) {
        this.$logger.warn(this.schemaName + "処理がキャンセルされました。");
        const systemLogMessage = !result
          ? "ClaioSchemaがフロントエンドの中止ボタンで処理中断されました。"
          : "ClaioSchemaがシェーマ画面のキャンセルボタンで処理中断されたか、もしくは2重起動により起動できませんでした。";
        this.addSystemLog(systemLogMessage);
        return null;
      }
      if (!(result instanceof ClaioSchemaExecuteResult) || !result.isComplete) {
        throw new Error(this.schemaName + "の処理を完了できませんでした。");
      }
      this.addSystemLog("ClaioSchemaの処理が完了しました。");
      return result;
    } catch (e) {
      this.$error(this.schemaName + "起動失敗", this.schemaName + "処理が完了できませんでした。", e);
      this.addSystemLog("ClaioSchemaの処理が完了できませんでした。");
      return null;
    }
  }

  private addSystemLog(message: string) {
    try {
      this.$logger.info("[SystemLog] " + message);
      const repo = DomainRegistry.system.getLogRepository();
      const info = new SystemLogInformation();
      info.level = SystemLogEventLevelKinds.Info;
      info.message = message;
      // システムログの登録完了は待たずに処理を進める
      repo.addSystemLog(info);
    } catch (e) {
      this.$logger.warn(e);
    }
  }

  private toEditRequest(source: IImageDrawable): ClaioSchemaExecuteRequest {
    const request = new ClaioSchemaExecuteRequest();
    request.user = this.$store.getters.user;
    request.patient = this.source.attributes.patient;
    request.department = this.shouldExecuteWithDocumentDepartment ? this.source.attributes.department : null;
    request.originalImageSourceUrl = this.getOriginalImageSourceUrl(source);
    request.currentImageSourceUrl = source.imageSource.source;
    request.drawLayerImageSourceUrl = source.drawLayerImageSource.source;
    request.drawObjectData = source.drawObjectData;
    return request;
  }

  private getOriginalImageSourceUrl(source: IImageDrawable): string {
    return (source.originalImageSource && source.originalImageSource.imageSourceKind !== ImageSourceKinds.None)
      ? source.originalImageSource.source
      : null;
  }

  get editParameters(): Dictionary<string, string> {
    const dictionary = new Dictionary<string, string>();
    const actionKeyword = this.$configuration.behavior.document.editor.contents.schema.shouldExecuteCNoteSchema
      ? "cNoteSchema"
      : "claioSchema";
    dictionary.set("action", actionKeyword);
    return dictionary;
  }

  get schemaName(): string {
    return this.$configuration.behavior.collaboration.schema.imageName;
  }

  get shouldExecuteWithDocumentDepartment(): boolean {
    return this.$configuration.behavior.document.editor.contents.schema.shouldExecuteWithDocumentDepartment;
  }
}
